// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View_wrapper__1eoN9","header":"View_header__1hm5i","footer":"View_footer__2AN49","tabs":"View_tabs__2XcFe","spin":"View_spin__1JYjS"};